export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Главная", "item": { "@id": "https://business-training.by/", "name": "Главная" } },
          { "@type": "ListItem", "position": 2, "name": "Энциклопедия корпоративного обучения", "item": { "@id": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie", "name": "Энциклопедия корпоративного обучения" } },
          { "@type": "ListItem", "position": 3, "name": "Обучение отдела продаж", "item": { "@id": "https://business-training.by/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh", "name": "Обучение отдела продаж" } }
        ]
      },
      {
        "@type": "Service",
        "name": "Обучение отдела продаж",
        "description": "Корпоративное обучение менеджеров по продажам с диагностикой, практикой и сопровождением внедрения. Рост конверсии и эффективности команды.",
        "provider": {
          "@type": "Organization",
          "name": "BusinessTraining.by",
          "url": "https://business-training.by",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Минск",
            "addressCountry": "BY"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+375255024478",
            "contactType": "sales"
          }
        },
        "areaServed": ["BY", "RU", "KZ"],
        "serviceType": "Корпоративное обучение",
        "offers": {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Программа обучения отдела продаж"
          }
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          { "@type": "Question", "name": "Что такое обучение отдела продаж?", "acceptedAnswer": { "@type": "Answer", "text": "Обучение отдела продаж — это системный процесс развития профессиональных компетенций менеджеров по продажам, направленный на рост бизнес-показателей. В отличие от разовых тренингов, системное корпоративное обучение включает диагностику, разработку индивидуальной программы, практическую отработку, внедрение и сопровождение." } },
          { "@type": "Question", "name": "Чем обучение отдела продаж отличается от тренинга?", "acceptedAnswer": { "@type": "Answer", "text": "Тренинг — это один из форматов обучения, обычно интенсивное занятие на 1-2 дня. Обучение отдела продаж — более широкое понятие, включающее диагностику, адаптацию программы, практику, внедрение и сопровождение." } },
          { "@type": "Question", "name": "Как проходит обучение отдела продаж?", "acceptedAnswer": { "@type": "Answer", "text": "Обучение проходит в несколько этапов: заявка, экспресс-диагностика, аудит, подготовка программы, проведение обучения (80% практики), домашние задания, посттренинговое сопровождение и оценка результатов по KPI." } },
          { "@type": "Question", "name": "Можно ли обучать отдел продаж онлайн?", "acceptedAnswer": { "@type": "Answer", "text": "Да, онлайн-обучение — эффективный формат для распределённых команд. Современные платформы позволяют проводить интерактивные тренинги с сохранением качества. Смешанный формат даёт наилучшие результаты." } },
          { "@type": "Question", "name": "Как оценить эффективность обучения отдела продаж?", "acceptedAnswer": { "@type": "Answer", "text": "Эффективность оценивается по модели Киркпатрика: реакция участников, усвоение знаний, изменение поведения и бизнес-результаты. Ключевые метрики: конверсия, средний чек, повторные продажи, retention rate." } }
        ]
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении, продажах и управлении. 100+ корпоративных проектов, 450+ тренингов, 4500+ участников.",
        "url": "https://www.linkedin.com/in/alekseysivko",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}